//messages.js
export default {
    title: "AELU",
    ssv: "特定技能ビザ",
    what_ssv: "特定技能ビザとは",
    representative_message: "代表メッセージ",
    aeru_feature: "AELUの特徴",
    aeru_how_to_use: "ご利用の流れ",
    aeru_q_a: "Q&A",
    aeru_function: "AELUの機能",
    aeru_fee: "AELUの料金",
    login: "ログイン",
    db_top_comment1: "業界初！「特定技能ビザ検定試験」スマホオンライン研修サイト",
    db_top_comment2: "AELU（アエル）は特定技能ビザ取得を、試験勉強・試験情報・申し込み代行で\n支援するWebサービスです。",
    db_top_pr: "「特定技能ビザ」を使って、\n新たなチャンスを掴もう",
    member_regist: "会員登録",
    registration_support_organization: "登録支援機関とは？",
    rso_dec1: "特定技能の制度には「特定技能所属機関」と「登録支援機関」という２つの機関があります。特定技能所属機関とは、特定技能外国人を雇用する会社（受入れ機関）です。 特定技能所属機関は、特定技能外国人の職場上、日常生活上、社会上の支援をしなければいけません。",
    rso_dec2: "特定技能外国人の支援には専門的な内容もあるため、特定技能外国人を雇用する会社「特定技能所属機関」自身で実施するのは難しいというケースもあります。 登録支援機関とは、特定技能所属機関に委託されて特定技能外国人の支援計画の作成・実施を行う機関です。",
    rso_dec3: " 登録支援機関とは、特定技能所属機関に委託されて特定技能外国人の支援計画の作成・実施を行う機関です。",
    rso_dec4: "登録支援機関は、受入れ機関との支援委託契約により、１号特定技能外国人支援計画に基づく支援の全部の実施を行います。",
    rso_dec5: "○ 登録支援機関になるためには、出入国在留管理庁長官の登録を受ける必要があります。",
    rso_dec6: "○ 登録を受けた機関は、登録支援機関登録簿に登録され、出入国在留管理庁ホームページに掲載されます。",
    rso_dec7: "○ 登録の期間は５年間であり、更新が必要です。",
    rso_dec8: "○ 登録支援機関は、出入国在留管理庁長官に対し、定期又は随時の各種届出を行う必要があります。",
    article1: "特定技能ビザとは？",
    article1_dec1: "２０１８年１２月８日改正出入国管理法の成立により在留資格「特定技能」の新設されました。２０１９年４月に施行。",
    article1_dec2: "新たな在留資格「特定技能」を２段階にて設ける。（１号、２号）",
    article1_dec3: "対象となる業種は１４業種。 ",
    article1_dec4: "対象となる外国人の要件は「相当程度の知識または経験を要する技能」を持つ者。つまり、技能実習３年を満了した者か、それと同等の日本語及び技能試験に合格した者が対象となる。",
    article1_dec5: "「特定技能１号」は一定の技能を有する者として、最長で５年の在留が認められる。家族の帯同は認めない。",
    article1_dec6: "「特定技能２号」は熟練技能を有する者として、特定技能１号の期間に専門級となる試験に合格することで、一般的な就労と同等の在留資格を与えられる。\n（在留期間の更新によって事実上永住可能、家族帯同を認める。）",
    article2: "代表メッセージ",
    article2_sub1: "まだ日本を、\n見捨てないでください",
    article2_dec1: "技能実習生として日本国へ来日し、技能を習得し自国の発展の為に努力を惜しまない多くの技能実習生、帰国実習生に心から感謝申し上げます。今の日本にない、何かを達成する為に事を選ばず家族の為、自国の為に実習している姿は本来の人間の姿であると思います。技能実習生事業に長く携わらせてもらっている中で、技能実習生ビザでしか入国する手立てがなくそのチャンスを生かし、日本国でしっかり実習をし、自国で開業し大きく自国の発展している姿を多くみました。しかし、規定年数では学びきれない、まだ日本を堪能したいという想いが叶えられるビザ「特定技能ビザ」が2019年4月に施工されました。日本国には今少ない、目の奥にある野心を持つ多くの来日外国人皆さんにより共に日本国の発展をすることできればと思います。何より日本という国を好きになってもらい、永住者が増え、共住できる社会を作り上げて参りたいと思います。",
    article2_dec2: "株式会社見える化",
    article2_dec3: "代表取締役社長",
    article2_dec4: "堀内和彦",
    article3: "AELU（アエル）が提供する3つの特徴",
    article3_sub1: "オンライン試験勉強",
    article3_sub1_dec1: "スマホで特定技能検定試験対策ができる「AELU」過去問を始め、擬似問を専門家にて14業種全て30問題後ど用意し、試験日に向けて何度でも対策が可能です。AIにてはじき出される問題において規定点数を越えれば必ず試験に合格します！",
    article3_sub2: "試験情報",
    article3_sub2_dec1: "訪日外国人の方には大変わかりにくい試験情報を、登録後選択した業種の試験情報が更新されると自動で追加となり、ユーザーに通知いたします。",
    article3_sub3: "試験申し込み代行",
    article3_sub3_dec1: "試験情報同様試験の申し込みにおいては、訪日外国人皆さんには大変難しくオンラインで手続きしない事には試験を受けることすらできません。登録した時点で情報を転記し、申込書を既に保有し、試験発表と同時に一斉に申し込みができる仕組みです。",
    article4: "試験合格後機能紹介",
    article4_sub1: "合格者お祝いキャッシュバック\n（国内、国外問わず）",
    article4_sub1_dec1: " 既に日本国に在住している方が、AELUを利用し合格し、自身のユーザー画面へ合格番号と合格証のアップロードすれば、即日キャッシュバック キャッシュバック予定商品：オンラインギフト券（アマゾンギフト券Eメールタイプ、Googleplay、iTunesギフトカード）5000円相当をLINE公式アカウントからキャッシュバック",
    article4_sub2: "友達紹介キャンペーン",
    article4_sub2_dec1: "国内、国外にいる日本へ来日希望者をFBグループに招待し、ユーザーは自身の管理番号を教えその番号に紐づく方にキャッシュバック、入会し１ヶ月経ったら紹介者へオンラインギフト券を1000円キャッシュバックします。",
    article4_sub3: "ビザ取得後、仕事探しは\nAI自動マッチング",
    article4_sub3_dec1: "AELUを利用し、検定試験合格後、ユーザー画面にて合格番号、合格証をアップロードいただくと、日本国内のあらゆる企業から自動オファーが届きます。面談も、オンラインで行い、事前の内定章においてもオンラインで結び、安心して入国、引越しをし仕事につけます！",
    // article4_sub4: "在留カード定期チェックで\nキャッシュバック（未定）",
    // article4_sub4_dec1: "在留カードチェックアプリ「ワンチェックタブ 」において、アエルないで１ヶ月に1回在留カードをチェックしたら1年で1万円キャッシュバック",
    article5: "具体的な機能紹介",
    article5_sub1: "解いた問題の振り返りができる",
    article5_sub1_dec1: "自分がオンライン研修した試験内容が蓄積し、独自のツールを使い、ユーザーの癖を理解し苦手な問題を克服できます。何度でも試験対策ができる為、点数の履歴や試験時間などを全て記録し、実際の試験当日にできる限り近づけます。また、自国語と日本語を併用し記載する為、より質問を理解することができます。",
    article5_sub2: "入国時の履歴書を永久保存",
    article5_sub2_dec1: "特定技能ビザ試験を受かりビザ申請をする際に、技能実習生として入国した時点での履歴書が必須となります。本来管理団体（協同組合）や送り出し機関にて保管されているが特定技能ビザ取得後は、各自で保管できます。",
    article5_sub3: "自分の国、分野の登録機能",
    article5_sub3_dec1: "自国の言語と日本を併用で記載する為、質問に対してよく理解し対策ができます。本来の試験では、日本語のみとなる為、日本語のみで対策もできます。",
    article5_sub4: "検定試験の要項や情報のリマインド",
    article5_sub4_dec1: "希望職種においての試験日程が各試験団体がHPへUPした場合に自動でリマインドし、ユーザーに通知され、ユーザー画面で試験日を設定しタイマーが自動で作動します。",
    article5_sub5: "スクリーニングを利用した学習",
    article5_sub5_dec1: "ユーザーの不得意な部分を抽出し、試験対策ができます。",
    article5_sub6: "スマホのカメラを利用したオンラインでの学習相談、面談",
    article5_sub6_dec1: "アエルを利用して検定試験対策を進める中で、問題の意味や意図等を明がオンライン通話やチャット形式でできるものとなります。日本に慣れている方、よく理解している方には必要ないかもしれませんが、基本通話での相談サービスは試験までに不安な点を確認するには一番安心します！",
    article6: "料金",
    article6_sub1: "AELU（アエル）使用料金",
    article6_sub1_dec1: "特定技能ビザ検定試験の勉強が無制限で可能。 母国語でオンライン電話にて相談可能※通常時、通訳としても活用可能。\n試験当日、試験会場までのアナウンス可能。\n入国時履歴書永遠に保存可能。\n試験合格後、特定技能ビザ合格番号を登録するだけで、希望の仕事を紹介。（未定）",
    article6_sub2: "試験申込代行",
    article6_sub2_dec1: "仕事中に申し込みはできなく、申し込みをしない限り検定試験を受けれらない為、検定試験情報が上がった時点で即申し込みを代行し、試験日を逃さないようにします。",
    article7: "キャッシュバックキャンペーン実施中！",
    article7_dec1: "試験に合格した方の中からビザの番号を、本サービスに登録した方に、もれなく、5,000\n円のキャッシュバック！キャンペーンの参加方法はこちら",
    article8: "さぁ、AELU（アエル）に登録しましょう！",
    dashboard: "ダッシュボード",
    member_info: "プロフィール情報の登録",
    first_name: "名",
    midle_name: "ミドルネーム",
    family_name: "姓",
    half_width_Roman: "ローマ字半角",
    password: "パスワード",
    password_confirm: "パスワード(確認)",
    mail_adress: "メールアドレス",
    lineId: "LINE ID",
    country_id: "国コード",
    phone: "電話番号",
    issuing_country: "身分証の発行国/地域の選択",
    IDtype: "IDタイプの選択",
    residence_card: "在留カード or IDカード",
    passport: "パスポート",
    regist: "登録",
    is_required: "は必須です",
    sign_up: "新規登録",
    residence_front: "表面のアップロード",
    residence_back: "裏面のアップロード",
    passport_upload: "パスポートをアップロード",
    error_file: "画像をアップロードしてください",
    post_resume: "履歴書の提出",
    resume_upload: "履歴書のアップロード",
    click_upload: "クリックしてアップロード",
    image_drop: "または画像ファイルをドラッグ＆ドロップ",
    select_language: "母国語の選択",
    vietnamese: "ベトナム語",
    chinese: "中国語",
    english: "英語",
    khmer: "クメール語",
    indonesian: "インドネシア語",
    tagalog: "タガログ語",
    burmese: "ビルマ語",
    hindu: "ヒンドゥー語",
    lao: "ラーオ語",
    mongolian: "モンゴル語",
    bengali: "ベンガル語",
    sinhala: "シンハラ語",
    banglodesh: "バングラディッシュ語",
    malay: "マレー語",
    nepali: "ネパール語",
    thai: "タイ語",
    japanese: "日本語",
    error_lang: "母国語を選択してください。",
    select_ouccupation: "職種の選択",
    select_max_three: "最大3つまで選択可能です。",
    industry_id_1: "介護業",
    industry_id_2: "ビルクリーニング業",
    industry_id_3: "素形材産業",
    industry_id_4: "産業機械製造業",
    industry_id_5: "電気・電子情報関連産業",
    industry_id_6: "建設業",
    industry_id_7: "造船・舶用業",
    industry_id_8: "自動車整備業",
    industry_id_9: "航空業",
    industry_id_10: "宿泊業",
    industry_id_11: "農業",
    industry_id_12: "漁業",
    industry_id_13: "飲食料品製造",
    industry_id_14: "外食業",
    industry_id_15: "素形材・産業機械・電気電子情報関連製造業",
    industry: "業種",
    error_occupation: "職種を1つ以上選択してください。",
    do: "する",
    news_tpic: "ニュース",
    days_until_exam: "の試験までの残り日数",
    estimated_pass_rate: "推定合格率",
    average_score_taken: "勉強した自分のテストの平均点",
    exam: "試験は",
    let_aim: "を目指しましょう",
    score: "点",
    solve_problem: "の問題を解く",
    recommend_problem: "類似試験問題",
    solved_problem: "自分が過去に解いた問題",
    実際に: "実際に出た過去問題を見る>",
    学習相談サービス: "学習相談サービス",
    application_agency: "試験申し込み代行サービス",
    billing: "課金",
    more_look: "もっと見る>",
    more_look2: "もっと見る",
    facebook: 'Facebook',
    google: "Google",
    until_not_account: "まだアカウントをお持ちではない方は、",
    or: "または",
    other_way: "他の方法で、",
    not_have_account: "アカウントをお持ちでない方は、",
    have_account: "アカウントをお持ちの方は、",
    forgot_password: "パスワードをお忘れの方はこちら",
    this: "こちら",
    at_login: "でログイン",
    pass_condition: "半角英数,大文字,記号8文字以上",
    at_sign_up: "で新規登録",
    agreement1: "以下の同意して続行を選択することで、AELUの",
    terms: "サービス利用規約",
    agreement2: "に同意します。",
    agree: "同意して続行",
    account_confirm: "確認コード",
    confirm: "確認",
    not_confirm: "確認コードが未確認です。",
    move_confiirm: "確認コードの入力画面に移動します",
    top: "トップ",
    news_list: "ニュース一覧",
    problim_list: "問題一覧",
    learning_consul: "学習相談",
    agency: "試験情報",
    of_trend: "の試験の動向について",
    start_test: "テストを開始する",
    study_mode: "学習モード",
    order_question: "問目",
    of_question: "問中",
    question_current: "問正解",
    to_mypage: "マイページへ",
    correct_answer: "正解!",
    correct_answer_normal: "正解",
    no_correct_answer: "不正解",
    next: "次の問題へ",
    finish_all: "全ての問題を回答しました！",
    your_score: "あなたの点数は",
    is: "です!",
    result_description: "「問題一覧を見る」から、他の問題を解くことができます。問題一覧ページから、過去に解いた問題の振り返りをすることも可能です。",
    back_quiz_list: "問題一覧を見る >",
    retry: "もう一度この問題を解く >",
    no_description: "解説はありません",
    show_ans: "解答を見る",
    of_solved_problem: "の過去に解いた問題",
    of_solved_problem_list: "の過去に解いた問題一覧",
    solved_description: "の特定技能ビザ試験のための学習テストの振り返りができます。",
    before_result: "前回の成績",
    looking_back: "振り返し",
    back_solved_problem_list: "過去に解いた問題一覧を見る",
    again_retry: "もう一度この問題を振り返る",
    done_member_regist: "会員登録ありがとうございます！",
    done_member_regist_description: "各サービスは、サービス利用料をお支払いいただいた後に、ご利用が可能になります。 \nお支払い情報の登録をお願いします。",
    choose_payment: "お支払い方法を選ぶ",
    service_content: "サービス内容",
    test_info_service: "試験情報提供サービス",
    usage_fee: "利用料金",
    test_fee: "550円",
    application_fee: "22,000円",
    method_payment: "支払い方法",
    LINE_pay: "LINE Pay",
    line_pay_description: "※QRコード画像を保存し、LINE Payのサービス内で決済をしてくださいLINE Payでお支払いの場合は、運営側での確認にお時間をいただきます。",
    save_qr: "QRコードを保存",
    next_stage: "次へ",
    credit_card: "クレジットカード",
    copmplete_payment: "お支払いが完了しました。",
    copmplete_payment_descript: "お支払いが完了いたしましたので、オンライン試験勉強機能、試験情報、試験申込代行サービスのご利用が可能になりました。",
    start_sevice: "サービスの利用を開始する",
    to_payment: "支払い画面へ",
    of_news_list: "ニュース一覧",
    done_payment: '支払いが完了しました。',
    tv_consult: "TV電話相談",
    tell_consult: "電話相談",
    learning_consul_descript01: "試験申し込みの",
    learning_consul_descript02: "代行を行います",
    money_unit: "円",
    learning_consul_unit: "１回",
    fault_payment1: "支払いが失敗しました。",
    fault_payment2: "もう一度やり直してください。",
    no_examination: "まだありません",
    no_exam: "まだ試験がありません",
    undecided: "未定",
    retry_login: "再度ログインをしてください",
    no_problem: "解いた問題がありません",
    do_problem: "問題を解く",
    qa_title: "よくある質問",
    search_category: "カテゴリーで絞り込む",
    search_freeward: "フリーワードで検索",
    test_result: "模擬試験結果",
    to_top: "トップへ",
    missPassword: "パスワードかメールアドレスが間違っています",
    sample_problem: "オンライン試験勉強を体験してみよう",
    exercises: "練習問題",
    let_exercises: "実際の問題を1問だけ解いてみましょう！",
    to_qa: "Q&Aをもっと見る",
    read_more: "もっと見る",
    account_setting: 'アカウント設定',
    profile_setting: 'プロフィール設定',
    notification_setting: '通知設定',
    logout: 'ログアウト',
    changeEmail: 'メールアドレスを変更',
    changePassword: 'パスワードを変更',
    change: '変更する',
    save: '保存する',
    change_success: '変更できました',
    now_password: "現在のパスワード",
    new_password: "新しいパスワード",
    check_new_password: "新しいパスワード(確認)",
    do_logout: "ログアウトしました",
    done_learning_consul_payment: "既に支払いは完了しております。",
    past_exam: "過去問題",
    update_info: "最新情報を更新中",
    official_sns: "公式SNS",
    privacy_policy: "プライバシーポリシー",
    terms_service: "利用規約",
    transaction_law: "特定商取引法に基づく表記",
    selectCountry: "国を選択してください",
    goInquiry: "お問い合わせに進む",
    lineInquiry: "LINEでお問い合わせ",
    regist_accept_certificate: "技能検定試験合格書の登録",
    accept_certificate_description: "合格証明書と番号を登録することができます",
    accept_certificate: "合格証明書",
    accept_number: "合格番号",
    immigration_resume: "入国時履歴書登録",
    resendCode: '確認コードを再送する',
    line_at_register: "LINE@でサービスのお問い合わせ",
    study: "勉強・振り返りをする" ,
    study_text: "学習用教科書(テキスト)をダウンロード" ,
    do_resume_update: "履歴書のアップロードを行なってください" ,
    done_resume_update: "履歴書の登録ありがとうございました！" ,
    regist_resume_enter: '入国時履歴書の登録',
    about_company: '運営会社について',
    add_exam_info_detail: '試験情報が追加されました。詳細や申し込みはこちら',
    regist_result_get_money: '試験の結果を登録してお金を手に入れよう',
    detail: "詳細",
    about_withdrawal_subsc:"退会や定期支払い購読解除について",
    apply_withdrawal:"退会手続きの申請",
    apply_subsc:"定期支払い購読解除の申請",
    about_withdrawal: "退会申請",
    about_subsc: "定期支払い購読解除",
    exam_info: "試験情報",
    date: "日時",
    day: "日",
    place: "場所",
    result_publication: "合格発表",
    result_publication_place: "合格発表場所",
    result_this_page:"こちらのページで発表されます",
    exam_way: "試験形式",
    exam_way2: "試験の出題形式",
    include_exam_fee: "試験費用を含む",
    exam_application_desc: "試験への申し込み書提出の代行\n試験事務局とのやりとり\n当日までに準備するもののご連絡(LINE@)\n試験に関する不明点のご相談",
    self_application: "自分で申し込みを行う",
    application_method: "お申し込み方法",
    under_this_url: "以下のURLからお申し込み手続きを行なってください",
    do_appliction: "試験の申し込む",
    study_with_aeru: "トップページから試験勉強機能を使って合格率をあげよう",
    line_at_consul: "LINE@学習相談サービス",
    instagram: "Instagram",
    do_signup: "認証されました。\n再度ログインしてください。",
    gender: "性別",
    man: "男性",
    woman: "女性",
    input_problem_title: "問題のタイトルが入ります...",
    still_no_problem: "問題がありません",
    enter_in_problem_trend: "今までの試験の動向や回答形式（選択式）など簡単な試験の説明が入ります。",
    correct: "正解",
    explanation:"解説",
    problem: "問題",
    do_nursing_not_published: "介護業分野では試験は行われていますが、過去問が公開されていません",
    practical_exam_of_year:"年実技試験",
    judgment_test_of_year: "判断試験",
    judgment_test_answer_of_year:"2019年判断試験解答",
    not_yet_test_material: "素形材産業分野ではまだ試験が行われていない",
    not_yet_test_machinery: "産業機械製造業分野ではまだ試験が行われていない",
    not_yet_test_electronic: "電気・電子情報関連産業分野ではまだ試験が行われていない",
    not_yet_test_construction: "建設業分野ではまだ試験が行われていない",
    not_yet_test_shipbuilding : "造船・舶用業分野ではまだ試験が行われていない",
    do_automobile_not_published: "自動車整備業分野では試験は行われていますが、過去問が公開されていません",
    do_aviation_not_published: "航空業分野では試験は行われていますが、過去問が公開されていません",
    do_agricultural_not_published: "農業業分野では試験は行われていますが、過去問が公開されていません",
    do_fishery_not_published: "漁業分野では試験は行われていますが、過去問が公開されていません",
    do_food_not_published: "飲食料品製造業分野では試験は行われていますが、過去問が公開されていません",
    do_restaurant_not_published: "外食業分野では試験は行われていますが、過去問が公開されていません",
    schedule_undecided: "(※予定も未定）",
    year: "年",
    month: '月',
    texts_learning:'各業種学習用テキスト',
    texts_learning_test: '特定技能評価試験学習用テキスト(日本語)',
    skill_test_sample: "技能評価試験サンプル",
    japanese_test_sample: '日本語評価試験サンプル',
    not_building_texts:'ビルクリーニング業分野の学習テキストはまだありません',
    not_material_texts:'素形材産業分野の学習テキストはまだありません',
    not_machinery_texts:'産業機械製造業分野の学習テキストはまだありません',
    not_electronic_texts:'電気・電子情報関連産業分野の学習テキストはまだありません',
    not_shipbuilding_texts:'造船・舶用業分野の学習テキストはまだありません',
    not_automobile_texts:'自動車整備業分野の学習テキストはまだありません',
    not_accommodation_texts:'宿泊業分野の学習テキストはまだありません',
    not_food_texts:'飲食料品製造業分野の学習テキストはまだありません',
    not_restaurant_texts:'外食業技能測定試験学習用テキスト',
    each_depertment_texts:'各学科の試験学習用テキスト',
    skill_test_basic:'技能評価試験学習用テキスト(基本技術)',
    skill_test_safety:'技能評価試験学習用テキスト(作業安全・品質)',
    skill_test_aircraft:'技能評価試験学習用テキスト(航空機概要)',
    texts_livestock:'【畜産農業学習用テキスト】日本語版',
    texts_cultivated:'【耕種農業学習用テキスト】日本語版',
    skill_test_fishery:'漁業技能測定試験(漁業)',
    skill_test_general_fishery:'漁業技能測定試験(漁業一般)',
    skill_test_safety_fishery:'漁業技能測定試験(漁業安全)',
    skill_test_specialty_fishery:'漁業技能測定試験(漁業専門 網関係)',
    skill_test_related_fishery:'漁業技能測定試験(漁業専門 釣関係)',
    skill_test_aquaculture:'漁業技能測定試験(養殖業)',
    skill_test_general_aquaculture:'漁業技能測定試験(養殖業一般・安全)',
    skill_test_feeding_aquaculture:'漁業技能測定試験(給餌養殖関係)',
    skill_test_non_feeding_aquaculture:'漁業技能測定試験(無給餌養殖関係)',
    registration_skill_visa: "特定技能ビザ取得合格証明書の登録",
    please_register_pdf_number:'特定技能ビザ取得の合格証明書の写真 or PDFと合格証明書記載の合格番号を登録してください',
    regist_and_get_cash_bag:'現在登録していただけるとキャッシュバッグで5000円もらえます',
    thank_you_regist_visa_pass:'特定技能ビザ取得の合格証明書の登録ありがとうございました！',
    exam_info_detail: "試験の実施概要",

    em_exam_detail_language: "現地語を予定" ,
    em_exam_detail_method: "学科試験、実技試験",
    em_exam_detail_way: "コンピューター・ベースド・テスティング(CBT), ペーパーテスト方式又は製作等作業試験方法",
    em_exam_detail_section: "19試験区分（鋳造、鍛造、ダイカスト、機械加工、金属プレス加工、鉄工、工場板金、めっき、アルミニウム陽極酸化処理、仕上げ、機械検査、機械保全、電子機器組立て、電気機器組み立て、プリント配線板製造、プラスチック成形、塗装、溶接、工業包装）",
    em_exam_detail_notify: "試験後、Eメールで結果通知書を送付",
    em_exam_detail_border: "学科試験: 65%以上\n実技試験: 60点以上",
    ss_exam_detail_language: "日本語" ,
    ss_exam_detail_method: "技能試験は、実技試験及び学科試験によって行う。\n実技試験は、業務区分ごとに試験を行う。\n学科試験は、ペーパーテスト方式により業務区分ごとに試験を行う。",
    ss_exam_detail_way: "ペーパーテスト方式、その他",
    ss_exam_detail_section: "学科・実技・技能: 溶接、塗装、鉄工、仕上げ、機械加工、電気機器組立て",
    ss_exam_detail_notify: "--",
    ss_exam_detail_border: "学科試験: 60%以上\n実技試験: 実技成果により判断",
    c_exam_detail_language: "日本語" ,
    c_exam_detail_method: "技能試験は、実技試験及び学科試験によって行う。",
    c_exam_detail_way: "コンピューター・ベースド・テスティング(CBT)、実技試験は登録法人が定める方法",
    c_exam_detail_section: "--",
    c_exam_detail_notify: "ホームページにて公表",
    c_exam_detail_border: "学科試験: 65%以上\n実技試験: 実技成果により判断",
    cm_exam_detail_language: "日本語" ,
    cm_exam_detail_method: "技能試験は、実技試験及び学科試験によって行う。",
    cm_exam_detail_way: "コンピューター・ベースド・テスティング(CBT)により、学科試験及び実技試験を行う",
    cm_exam_detail_section: "学科試験の科目\nア 構造、機能及び取扱法に関する初等知識\nイ 点検、修理及び調整に関する初等知識\nウ 整備用の試験機、計量器及び工具の構造、機能及び取扱法に関する初等知識\nエ 材料及び燃料油脂の性質及び用法に関する初等知識\n実技試験の科目\nア 簡単な基本工作\nイ 分解、組立て、簡単な点検及び調整\nウ 簡単な修理\nエ 簡単な整備用の試験機、計量器及び工具の取扱い",
    cm_exam_detail_notify: "--",
    cm_exam_detail_border: "学科試験: 65%以上\n実技試験: 得点合計が60%以上",

    a_exam_detail_language: "現地語および日本語" ,
    a_exam_detail_way: "コンピューター・ベースド・テスティング(CBT), ペーパーテスト方式",
    a_exam_detail_section: "① 学科\n耕種農業一般, 安全衛生, 栽培作物の品種・特徴, 栽培環境（施設・設備・資材・機械）, 栽培方法・管理, 病害虫・雑草防除, 収穫・調整・貯蔵・出荷\n②  実技\n土壌の観察, 肥料・農薬の取扱い, 種子の取扱い, 環境管理、資材・装置・機械の取扱い, 栽培に関する作業, 安全衛生\n ③ 日本語\n 日本語で指示された農作業の内容等の聴き取り",
    a_exam_detail_notify: "ホームページにて公表",
    a_exam_detail_border: "総合得点に対し、全国農業会議所が定める判定基準点を越えていること",

    avi_exam_detail_method: "技能試験は、実技試験及び学科試験によって行う。",
    avi_exam_detail_section: "学科\n日本航空技術協会のホームページに掲載するテキストの中から出題します。実技\n締結, 電気計測",
    avi_exam_detail_notify: "--",
    avi_exam_detail_border: "学科試験: 65%以上\n実技試験: 得点合計が65%以上",

    f_exam_detail_language: "日本語" ,
    f_exam_detail_method: "技能試験は、実技試験及び学科試験によって行う。",
    f_exam_detail_way: "コンピューター・ベースド・テスティング(CBT)により、学科試験及び実技試験を行う",
    f_exam_detail_section: "試験科目は漁業分野（漁業）又は漁業分野（養殖業）における一定程度の業務について、監督者の指示を理解し的確に遂行できるまたは自らの判断により遂行できることを確認するものとし、単に専門的な知識の有無を評価するものではなく、漁業分野（漁業）又は漁業分野（養殖業）における作業の遂行に必要な正しい判断力及び作業に関する知識の有無についても評価できるものとする",
    f_exam_detail_notify: "ホームページにて公表",
    f_exam_detail_border: "筆記試験及び実技試験の合計得点が技能試験実施機関の定める判定基準点を超える者を合格とする",

    no_exam_info: "まだ、試験概要情報は発表されていません",
    language: "実施言語",
    method: "実施方法",
    way: "実施方式",
    section: "試験区分",
    notify: "試験結果の通知",
    border: "試験結果の基準",
    go_line_at: "ライン@へ",
    thank_you_and_deactivate: "ご利用ありがとうございます。\nサービス退会の手続きについては、以下のライン＠窓口から退会の手続きと入力してください。\n定期支払いの解約については、以下のライン＠窓口から定期支払いの解約と入力してください。\n確認が取れ次第手続きを行います",
    thank_you_and_subscribe: 'ご利用ありがとうございます。\n定期支払いの解約については、以下のライン＠窓口から定期支払いの解約と入力してください。\n確認が取れ次第解約の手続きを行います',
    ten_thousand_yen: '万円',
    yen_per_month: '円 / 月',
    how_to_use_this_service: 'ご利用の流れ',
    selecting_a_browser: 'ブラウザの選定',
    selecting_a_browser_dec: 'ブラウザ（Googlechrome、Safari、edge等）にてhttps://aelu.co.jpにアクセス ※アプリはありません',
    provisional_registration: '仮登録',
    provisional_registration_dec: 'Facebook、GoogleIDにてログインもしくはメールアドレスにて登録。 希望言語、希望職種を選択後、オンライン検定試験模擬内容を閲覧可能。',
    full_registration: '本登録',
    full_registration_dec: 'オンライン検定模擬試験内容ページにある「本登録」をクリックし、必要情報を記入し、１４業種検定試験模擬問題初め全てのサービスを使用可能。',
    name_validate_message: "パスポートの記載と同じスペルで情報を入力してください",

    live_at_area: "現在住んでいる地域",
    agency_application: "試験申込を代行する",
    mypage: "マイページ",
    myanmar: "ビルマ語",
    exam_list: "試験日程一覧",
    no: "第",
    times: "回",
    application_start: "申込開始",
    application_end: "申込を締め切りました",
    enforcement: "実施",
    applicated: "申込済",
    reception_time: "受付時間",
    announthment_d: "合格発表日",
    reception_period: "申し込み期間",
    detail_link: "詳細を見る",
    exam_country: "開催国",
    line: "LINE",
    vietnum: "ベトナム",
    laos: "ラオス",
    malaysia: "マレーシア",
    bangladesh: "バングラディッシュ",
    indo: "インド",
    nepal: "ネパール",
    mongol: "モンゴル",
    indonesia: "インドネシア",
    th: "タイ",
    philipine: "フィリピン",
    my: "ミャンマー",
    uzbekistan: "ウズベキスタン",
    pakistan: "パキスタン",
    japan: "日本",
    news_title: "特定技能ビザに関するニュース",

    missNowPassword: "現在のパスワードが間違っています",
    article6_sub2_dec2: "こちらを申し込むと全てこちらで試験申込から試験代金、当日までの会場のアナウンスもします。",

    create_naw_password: "パスワードの変更",
    send_confirmcode: "確認コードが送信されました",
    edit: "変更する",
    success_new_password_setting: "新しいパスワードの設定ができました。",
    error_email: "登録されていないメールアドレスです。",

    click_here_businesses: '事業者はこちら',
    regist_organization_staff_info: '事業者・ユーザ情報の登録',
    organization_info: '事業者情報',
    staff_info: 'ユーザ-情報',
    org_name: '事業者名',
    url: 'URL',
    org_scale: '規模',
    org_zip: '郵便番号',
    org_adress1: '都道府県',
    org_adress2: '市区町村',
    org_adress3: '番地・マンション名',
    org_industry: '業種',
    org_category: 'カテゴリー',
    org_description: '説明',
    org_established_at: '設立年',
    org_phone: '事業者電話番号',
    failed_established_at: '無効な日付です。',
    staff_name: 'ユーザー名',
    form_miss: '入力フォームに間違いがあります。',

    back_joboffer_detail: '求人詳細に戻る　＜',
    create_joboffer: '求人を作成',
    edit_joboffer: '求人を編集',
    stop_posting: '掲載をやめる',
    delete: "削除する",
    job_title: '職種名',
    job_catch_phrase: '求人キャッチコピー',
    job_category: '職種カテゴリー',
    employed_company_name: '雇用企業名',
    work_location: '勤務地',
    employment_status: '雇用形態',
    full_time_employee: '正社員',
    part_time_job: 'アルバイト・パート',
    temporary_staff: '派遣社員',
    contract_employee: '契約社員',
    intern: 'インターン',
    subcontracting: '業務委託',
    contract: '請負',
    new_graduate: '新卒',
    salary: '給与',
    annual_income: '年収',
    monthly_salary: '月給',
    weekly_salary: '週給',
    dayly_salary: '日給',
    job_offer_attension1: '仕事内容は法令に従って所定の労働条件等を明示する必要があります',
    job_offer_attension2: '法令上、最低限明示することが必要な労働条件等をご確認のうえ、仕事内容をご記載ください。（ご参考：厚生労働省・都道府県労働局「労働者を募集する企業の皆様へ」）',
    job_offer_attension3: '対象者の年齢、性別、社会的身分を限定する文言を使うと求人を掲載できないことがあります。',
    job_offer_attension4: 'よくある掲載不可例：「20代歓迎」「年齢不問 (若手歓迎)」「女性歓迎・限定」「学生限定」',
    work_content_appeal: '仕事内容及びアピールポイント',
    work_content_appeal_desc: 'POINT：企業のPR写真になります。会社外観、社内、現場、社員の画像をアップするとイメージが伝わりやすくなります。',
    human_resources_seek: '求める人材',
    human_resources_seek_desc: 'POINT：求めるスキルはもちろん、求職者が職場をイメージできる情報も伝えましょう。',
    working_hours: '勤務時間・曜日',
    traffic_access: '交通アクセス',
    traffic_access_desc: '公共交通機関情報だけでなく、マイカー通勤、従業員向け駐車場の有無なども記載しましょう。',
    required: '必須',
    optional: '任意',
    other: 'その他',
    photo: '写真',
    upload_video: '動画をアップロードする',
    job_tag: '求人のタグ',
    until_select_three:'3つまで選択可能',
    senior_support: 'シニア応援',
    salary_increase_promotion: '昇給・昇格あり',
    no_overtime: '残業なし',
    target_hiring_time: '採用目標時期',
    additional_questions: '追加の質問',
    job_offer_title: '求人名',
    public: '公開',
    private: '非公開',
    public_status: '公開ステータス',
    occupation: '職種',
    walfare: '待遇・福利厚生',
    create: "作成する",
    hour: '時',
    back_mypage: 'マイページに戻る ＜',
    job_offers: '求人一覧',
    look_matches: 'マッチ一覧を見る',
    now_public: '公開中',
    now_private: '非公開中',
    check: '確認する',
    edit2: '編集する',
    news_detail: 'ニュース詳細',
    prefectures: '都道府県',

    hokkaido: '北海道',
    aomori: '青森',
    iwate: '岩手',
    miyagi:'宮城',
    akita: '秋田',
    yamagata: '山形',
    fukushima: '福島',
    ibaraki: '茨城',
    tochigi: '栃木',
    gunma: '群馬',
    saitama: '埼玉',
    chiba: '千葉',
    tokyo: '東京',
    kanagawa: '神奈川',
    niigata: '新潟',
    toyama: "富山",
    ishikawa: '石川',
    fukui: '福井',
    yamanashi: '山梨',
    nagano: '長野',
    gifu: '岐阜',
    shizuoka: '静岡',
    aichi: '愛知',
    mie: '三重',
    shiga: '滋賀',
    kyoto: '京都',
    osaka: '大阪',
    hyogo: '兵庫',
    nara: '奈良',
    wakayama:'和歌山',
    tottori: '鳥取',
    shimane: '島根',
    okayama: '岡山',
    hiroshima: '広島',
    yamaguti: '山口',
    tokushima: '徳島',
    kagawa: '香川',
    echime: '愛媛',
    kochi: '高知',
    fukuoka: '福岡',
    saga: '佐賀',
    nagasaki: "長崎",
    kumamoto: '熊本',
    oita: '大分',
    miyazaki: '宮崎',
    kagoshima: '鹿児島',
    okinawa: '沖縄',

    sinhalese: 'シンハラ語',
    exam_region: '都道府県',
    exam_place_list: '会場一覧',
    exam_place_name: '試験会場名',
    care_evaluation_test: '介護技能実習評価試験',
    clean_building_test: 'ビルクリーニング業過去問題',
    answer: '解答',
    skill_test_measurement: '技能測定試験',
    exam_problem: '試験問題',
    fields: '田畑・野菜',
    gardening: '施設園芸',
    mushroom: 'きのこ',
    fruit: '果樹',
    dairy: '酪農',
    poultry: '養鶏',
    pig: '養豚',
    beginner: '初級',
    professional: '専門級',
    advanced: '上級',
    technical_training_test: '技能実習評価試験',
    exam_part: '試験問題一部',
    tokoha_fruit: '常葉果樹',
    deciduous_fruit: '落葉果樹',
    ver: '版',
    errata: '正誤表',
    form_work: '型枠施工',
    construction: '左官',
    tunnel_line: 'トンネル推進工',
    earth_work: '土工',
    loofing: '屋根ふき',
    elecommunication: '電気通信',
    reinforcing_contstruction: '鉄筋施工',
    reinforcing_joint: '鉄筋継手',
    wall_painting: '塗装(壁張り)',
    board_finish: 'ボード仕上げ、内装仕上げ',
    steeplejack: 'とび',
    spray_insulation: '吹き付けウレタン断熱',
    marine_civil: '海洋土木工',
    concrete_pumping: 'コンクリート圧送',
    construction_machinery: '建設機械施工',
    learning_text: '学習テキスト',

    basic_aircraft: '航空機の基本技術　締結、電気計測 ',
    worksafety_quality: '作業安全、品質',
    aircraft_overview: '航空機概要',
    fish_general: '漁業一般',
    fish_safety: '漁業安全',
    network_relations: '漁業専門　綱関係',
    fish_relations: '漁業専門　釣り関係',
    aquaculture_general: '養殖業一般',
    feeding_aquaculture: '養殖業専門　給餌養殖関係',
    unfed_aquaculture: '養殖業専門　無給餌養殖関係',
    attachment: '付属資料',
    glossary: '用語集',
    feneral_customer: '接客全般',
    food_dring_cooking: '飲食物調理',
    hygiene_management: '衛生管理',
    visa_application: '特定技能ビザ申請',
    certificate_residence_tax: '1.住民税の課税証明書(直近3年分)',
    salary_income_withholding : '2.給与所得の源泉徴収票の写し(直近2年分)',
    national_health_insured: '3.国民健康保険被保険者証の写し(本人が加入している場合)',
    national_health_payment: '4.国民健康保険料納付証明書',
    national_health_receipt: '5.国民健康保険料領収証書の写し',

    technical_intern_training2: '6.技能実習２号を良好に修了したことを証明する書類',
    need_the_following : '以下のいずれかが必要です。',
    pass_certificate_test_specialized : '・技能評価試験(専門級)の実技試験の合格証明書の写し',
    technical_intern_training3: '・技能検定(３級)の実技試験の合格証明書の写し',
    evaluation_record_technical_intern: '・上記の試験に合格していない場合は、技能実習生に関する評価調書を記載する必要があります。',
    cartificate_pass_basic_test: '7. 6の代わりとして国際交流基金日本語基礎テストの合格証明書の写し又は日本語能力試験(N4)以上の合格証明書の写しを提出することが出来ます。',
    change_permission_application: '8.変更許可申請書の写真(タテ４ｃｍ×ヨコ３ｃｍ)',
    resume_data_time_entry: '9.入国時履歴書データ',
    select_file: 'ファイルを選択',

    description_movie: '説明動画',
    how_to_use_movie: '使用方法説明動画',
    movie_news: '1. 特定技能ビザに関するニュース',
    movie_exam: '2. 試験日までの残りの日数',
    movie_predict_pass: '3. 推定合格率',
    movie_ave_study_test: '4. 勉強した自分のテストの平均点',
    movie_similar_exam: '5. 類似試験問題',
    movie_learning_text: '6. 学習用教科書（テキスト）のダウンロード',
    movie_solved_exam: '7. 自分が過去に解いた問題',
    movie_pased_exam: '8. 実際に出た過去問題を見るについて',
    movie_resume_regist: '9. 入国時履歴書登録',
    movie_pass_document_regist: '10. 技能検定試験合格書の登録',
    movie_agency_service: '11. 試験申し込み代行サービス',
    movie_consule_service: '12. 学習相談サービス',
    description_movie_trans: '日本語以外で視聴したい場合は、歯車のマークをクリックし、字幕、自動翻訳をクリックし母国語を選択してから視聴してください。',


    cultivated_agriculture_general: '耕種農業全般',
    livestock_agriculture: '畜産農業',
    介護: '介護',
    ビルクリーニング: 'ビルクリーニング',
    建設: '建設',
    自動車整備: '自動車整備',
    航空業: '航空業',
    農業: '農業',
    漁業: '漁業',
    飲食料品製造業: '飲食料品製造業',
    外食業: '外食業',
    型枠施工: '型枠施工',
    左官: '左官',
    コンクリート圧送: 'コンクリート圧送',
    トンネル推進工: 'トンネル推進工',
    建設機械施工: '建設機械施工',
    大工: '大工',
    屋根ふき: '屋根ふき',
    電気通信: '電気通信',
    鉄筋施工: '鉄筋施工',
    鉄筋継手: '鉄筋継手',
    "壁装　（壁張り）": '壁装　（壁張り）',
    "ボード仕上げ、内装仕上げ": 'ボード仕上げ、内装仕上げ',
    とび: 'とび',
    吹き付けウレタン断熱: '吹き付けウレタン断熱',
    海洋土木工: '海洋土木工',
    "航空機の基本技術 締結、電気計測": '航空機の基本技術 締結、電気計測',
    "作業安全、品質": '作業安全、品質',
    航空機概要: '航空機概要',
    耕種農業全般: '耕種農業全般',
    畜産農業: '畜産農業',
    漁業一般: '漁業一般',
    漁業安全: '漁業安全',
    "漁業専門 綱関係": '漁業専門 綱関係',
    "漁業専門 釣り関係": '漁業専門 釣り関係',
    養殖業一般: '養殖業一般',
    "養殖業専門 給餌養殖関係": '養殖業専門 給餌養殖関係',
    "養殖業専門 無給餌養殖関係": '養殖業専門 無給餌養殖関係',
    接客全般: '接客全般',
    飲食物調理: '飲食物調理',
    衛生管理: '衛生管理',
    日本語版: '日本語版',
    英語版: '英語版',
    クメール語版: 'クメール語版',
    インドネシア語版: 'インドネシア語版',
    "インドネシア語・正誤表": 'インドネシア語・正誤表',
    ネパール語版: 'ネパール語版',
    モンゴル語版: 'モンゴル語版',
    ビルマ語版: 'ビルマ語版',
    ベトナム語版: 'ベトナム語版',
    タイ語版: 'タイ語版',
    テキスト１: 'テキスト１',
    テキスト２: 'テキスト２',
    テキスト３: 'テキスト３',
    テキスト４: 'テキスト４',
    テキスト５: 'テキスト５',
    'ミャンマー(ビルマ)語版': 'ミャンマー(ビルマ)語版',
    'カンボジア(クメール)語版': 'カンボジア(クメール)語版',
    ミャンマー語版: 'ミャンマー語版',
    中国語版: '中国語版',
    付属資料: '付属資料',
    用語集: '用語集',

    invitation_code: '招待コード',
    exam_calender: '試験日程カレンダー',
    move_exam_detail: '試験日程詳細ページに移動しますか？',
    move: '移動する',
    plece_select_language: '言語を選択してください',
    select:'選択する',
    midle_category: '職種',
    select_industry_description: 'AELUは、スタートに置いては業種は３つまでしか選択できないので、自分が働いてみたい業種のみを選択ください。問題ないようであれば、次を押してください',
    done_member_regist_description_2:'これから、検定試験対策を沢山して特定技能ビザ取得に向けてAELUもサポート致します。',
    done_member_regist_2: '会員登録完了しました。',
    is_exist_user: '既に同じメールアドレスのユーザが存在しています。',
    invitation_code_description: '（送り出し機関、日本語学校からの招待コードを入れてください、入れないと費用決済画面が出てきますので打ち込み忘れないでください）',
    pleace_select_region: '開催都道府県を選択してください',
    pleace_add_messenger: 'すべての連絡は、Facebook messagerで送りますので必ず追加してくださいね',
    add_messenger_bot: '通知を受け取る',
    visa_application_description: '特定技能ビザ申請時、必要書類保管場所',
    check_agree: '同意してください',
    sample_title: 'ダミータイトルです。設定してください',
    sample_description: 'ダミー説明文です。設定してください。ダミー説明文です。設定してください。ダミー説明文です。設定してください。ダミー説明文です。設定してください。ダミー説明文です。設定してください。ダミー説明文です。設定してください。ダミー説明文です。設定してください。',
    create_profile_error: '入力に間違いがあります。項目を確認してください',
    setting_confirm: '入力内容を確認して登録してください',
    exam_learning: '試験学習',
    recommend_problem_solve: '類似試験問題を解く',
    of: 'の',
    see_solved_problem: '過去にあなたが\n解いた問題を解く',
    past_exam_collection: '過去に出た\n試験問題',
    any_application_registration: '各種申請登録',
    mypage_visa_application: '特定技能ビザ\n申請',
    applyt_exam_and_agent: '試験申し込み\n代行サービス申し込み',
    myapge_regist_accept_certificate: '技能検定試験\n合格書の登録',
    mypage_consultaion_service: '学習相談\nサービス',
    consultaion_service: '学習相談サービス',
    consult: '相談する',
    of_exam_day: 'の試験日',
    your_ave_score: 'あなたの\nテストの平均点',
    your_estimated_pass_rate: 'あなたの\n推定合格率',
    your_ave_score_fotter: 'あなたのテストの平均点',
    your_estimated_pass_rate_fotter: '推定合格率',
    mypage_study_text: '学習用教科書\nのダウンロード',
    exam_schedule: '試験日程',
    resident_caption_title: '●住居カードまたはIDカードのアップロードについて',
    resident_caption: '赤枠内の情報が確認できる住居カードまたはIDカードをアップロードしてください。\n期限を迎えていない有効な住居カードまたはIDカードをアップロードしてください。\nPDFかJPG形式のカラー画像をアップロードしてください。',
    password_caption_title: '●パスワードのアップロードについて',
    password_caption: '赤枠のように\n名前/写真/固有番号/生年月日/国籍/有効期限が確認できるパスポート画像をアップロードしてください。\n期限を迎えていない有効なパスポートをアップロードしてください。\nPDFかJPG形式のカラー画像をアップロードしてください。',
    title_help: 'ヘルプ',
    step3_title_help: 'あなたの情報を正しく入力してください。',
    lineid_input_help: 'LINEを開く→ホーム→設定→プロフィール→スクロールするとIDの表示があります。そのIDを入力してください。作成していない人は作成して入力してください。',
    country_input_help: 'あなたの国籍の国を選択してください。',
    area_input_help: 'あなたが現在住んでる地域の国を選択してください。',
    phone_input_help: 'あなたの電話番号を入力してください。',
    issuing_input_help: '身分証を発行した地域を選択してください。',
    idtype_input_help: 'IDタイプを選択してください。選択した方の写真を綺麗に撮影してアップロードしてください。斜めっていたり切れているところがないように真っ直ぐ撮影してください。',
    invitation_input_help: '招待コードがある場合は入力してください。',
    exam_menu_help: '実際の過去に出題された問題と似ている問題が出てきます。繰り返し問題を解いて試験に備えましょう。',
    past_menu_help: '過去にあなたが解いた問題が出ます。間違えたところなどを復習しましょう。',
    pastexam_menu_help: '実際過去にあった試験問題のテキストです。',
    text_menu_help: '学習用教科書を見て大事なところを勉強したり、問題のわからないところを調べたりできます。',
    visa_menu_help: '特定技能ビザの取得をお手伝いします。特定技能のビザを取得したい方はこちらから申請してください。',
    agency_menu_help: '特定技能試験の申し込みをこちらで代行して申し込みします。特定技能の試験を受けたい方はこちらから申請してください。',
    cer_menu_help: '特定技能試験を受験された方で、合格書がある方はこちらから登録してください。',
    service_menu_help: '何かわからないことがあったり、質問がある場合はこちらからチャットにてご連絡ください。',
    occu_title_help: '希望する職種を最大３つ選んでください。',
    back: '戻る',
    before: '前の問題へ',
    threads: '掲示板',
    create_thread: 'スレッドを作成',
    thread_title: 'タイトル',
    content: '内容',
    nickname: 'ニックネーム',
    updated_at: '更新日',
    thread_details: '投稿詳細',
    create_comment: '書き込みをする',
    send: '送信',
    job_detail: '求人情報詳細',
    jobs_list: '求人情報',
    working_image: '働き方紹介画像',
    retry_edit: '修正する',
    search: '検索する',
    enter_keyword: 'キーワードを入力',
    details_search: '詳細検索する',
    name: '名前',
    year_old: '年齢',
    country_of_origin: '出身国',
    region_of_origin: '出身地域',
    social_experience: '社会経験',
    job_seeker_dettail: '求職者詳細',
    furigana: 'フリガナ',
    country_of_citizenship: '国籍',
    history_in_japan: '日本在歴',
    now_address: '現住所',
    career: '経歴',
    level_japanese: '日本語レベル',
    drivers_license: '運転免許書',
    pr_movie: 'PR動画',
    regist_favorite: 'お気に入り登録',
    send_interview_info: '面接案内送信',
    old: '歳',
    scout: 'スカウトする',
    scout_comment: 'スカウトを決めた理由',
    select_job: '求人を選択',
    applicant_list: '求人応募者一覧',
    acceptance_date: '応募受付日時',
    jobs_title: '求人タイトル',
    applicant_name: '応募者氏名',
    selection_status: '選考状況',
    remarks: '備考',
    job_basic_info: '求人の基本情報',
    company_name: '貴社名',
    note_description: 'この情報は、求職者には表示されず、応募者と共有されることもありません。',
    number_employees: '従業員数',
    person_charge: 'ご担当者名',
    person_charge_phone: '電話番号（ご担当者様と連絡可能な番号）',
    regist_this_content: 'この内容で登録',
    working_place_description: '都道府県・市区町村または駅名',
    scouts_list: "スカウト一覧",
    message_box: "メールボックス",
    srilank: 'スリランカ',
    combodia: 'カンボジア',
    reselect: "ファイルを変更したい場合は「Upload your passport」をもう一度押し、再度選択してください",
    iphone_file: "iphoneの方は、HEICファイルからJPGファイルへと変換してからご利用ください",
    file_transmit: "ファイルを変換",


    search_job: "求人を探す",
    modify_resume: "あなたの履歴書編集",
    chat: "チャット",
    interview_schejule: "面談日程確認",
    how_to_use: "使い方ガイド",
    to_go_exam: "試験ページへ",
    job_howtouse_panel: "求人ページの使い方を見ます。",

    click_here_agency: '代理店はこちら',
}
